import { render, staticRenderFns } from "./LandingTile.vue?vue&type=template&id=4ae46adc"
import script from "./LandingTile.vue?vue&type=script&lang=js"
export * from "./LandingTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports